import { render, staticRenderFns } from "./OperatingBankAccount.vue?vue&type=template&id=285680e3&"
import script from "./OperatingBankAccount.vue?vue&type=script&lang=js&"
export * from "./OperatingBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./OperatingBankAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports